/**
 * 加载geojson面数据为模型，具有height属性
 * time:2020-6-29
 *
 */
import { Cartesian3, Color as CesiumColor, CustomDataSource, PolylineOutlineMaterialProperty
  } from "cesium/Cesium";

let BuildingModle = function(jsonData, options) {
      if (options) {
        this.color = options.color ? this._colorValue(options.color) : [0, 1, 1, 0.6];
        if (options.propertyName) {
          this.options = options;
        }
      } else {
        this.color = [0, 1, 1, 0.6];
      }
      this.source = new CustomDataSource("polygonDataSouce");
      this._loadModel(jsonData);
};

BuildingModle.prototype = {
  _colorValue(c) {
    let c1 = [c[0] / 255, c[1] / 255, c[2] / 255, c[3]];
    return c1;
  },
  getColorFromProperty(f) {
    let color = null;
    if (this.options) {
      this.options.colors.forEach(c => {
        if (c.value === f.properties[this.options.propertyName]) {
          let colorValue = this._colorValue(c.color);
          color = new CesiumColor(colorValue[0], colorValue[1], colorValue[2], colorValue[3]);
        }
      });
    } else {
      color = new CesiumColor(this.color[0], this.color[1], this.color[2], this.color[3]);
    }
    return color;
  },
  _loadModel(data) {
    data.features.forEach(f => {
      let color = this.getColorFromProperty(f);
      let positions = [];
      let linePositions = [];
      let height = f.properties.height;
      f.geometry.coordinates[0][0].forEach(c => {
        let position = Cartesian3.fromDegrees(c[0], c[1], 0);
        positions.push(position);
        let linePosition = Cartesian3.fromDegrees(c[0], c[1], height);
        linePositions.push(linePosition);
      });
      f.properties["monitor23Buildinginner"] = "Building";
      this.source.entities.add({
        polygon: {
          extrudedHeight: height,
          hierarchy: positions,
          perPositionHeight: false,
          material: color,
          outline: false
        },
        properties: f.properties
      });
      // this.source.entities.add({
      //       polyline: {
      //         positions: linePositions,
      //         width: 1,
      //         material: new PolylineOutlineMaterialProperty({
      //             color: color,
      //             outlineWidth: 0,
      //             outlineColor: CesiumColor.BLACK
      //         }),
      //         zIndex: 1
      //     },
      //     properties: f.properties
      //   });
    });
  },
  getColorByValue(value, colors) {
    let color = null;
      colors.forEach(c => {
        if (c.value === value) {
          let colorValue = this._colorValue(c.color);
          color = new CesiumColor(colorValue[0], colorValue[1], colorValue[2], colorValue[3]);
        }
      });
    return color;
  },
  setColor(propertyName, colors) {
    this.source.entities.values.forEach(e => {
      let value = e.properties[propertyName].getValue();
      let color = this.getColorByValue(value, colors);
      if (color) {
        if (e.polygon) {
          e.polygon.material = color;
        }
        if (e.polyline) {
          e.polyline.material = new PolylineOutlineMaterialProperty({
            color: color,
            outlineWidth: 0,
            outlineColor: CesiumColor.BLACK
          });
        }
      }
    });
  }

};

export default BuildingModle;

// 事例代码
// let bmodel = new BuildingModel(modelData,
//   { color: [0, 255, 0, 0.6],
//     propertyName: "id",
//     colors: [
//    { value: 1, color: [255, 0, 255, 1] },
//    { value: 2, color: [255, 0, 0, 1] },
//    { value: 3, color: [0, 0, 255, 1] }
//  ] });

//  window.viewer.dataSources.add(bmodel.source);
//  setTimeout(() => {
//    bmodel.setColor("id", [
//    { value: 1, color: [0, 0, 255, 1] },
//    { value: 2, color: [0, 0, 100, 1] },
//    { value: 3, color: [0, 255, 255, 1] }
//  ]);
//  }, 8000);
